var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Button, Input, ModalWindow, SelectCustom } from '../../../components';
import { useTranslation } from 'react-i18next';
import { request } from '../../../config/request';
import ReportActions from '../../../services/print/ReportActions';
import styles from './styles.module.scss';
import { Edit, Del, save_big } from '../../../icons';
import { toast } from 'react-toastify';
import { useTypeSelector } from '../../../hooks/useTypeSelector';
import TkSettings from './TkSettings';
import OwnScheduleSetting from './OwnScheduleSetting';
const ModalSet = ({ hideModal }) => {
    const { t } = useTranslation();
    const blockRef = React.useRef(null);
    const { id_avn_user } = useTypeSelector(state => state.authReducer);
    const [journalSet, setJournalSet] = useState([]);
    const [checkedStates, setCheckedStates] = useState([]);
    const [isModal, setIsModal] = useState(false);
    const [value, setValue] = useState({
        idsettings: 0,
        field: 0,
        on_off: 0,
        desc: ''
    });
    const [checked, setChecked] = useState(false);
    const [valueSearch, setValueSearch] = useState('');
    const [permUsers, setPermUsers] = useState([]);
    const [permForma, setPermForma] = useState([]);
    const [objForma, setObjPermForma] = useState([]);
    const [valuePermUser, setValuePermUser] = useState({
        value: null,
        label: ''
    });
    const [valuePermForma, setValuePermForma] = useState({
        value: null,
        label: ''
    });
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [checkAddForm, setCheckAddForm] = useState(false);
    const [addFormStatus, setAddFormStatus] = useState(false);
    const [editFormStatus, setEditFormStatus] = useState(false);
    const change = (e) => {
        if (/^\d$/.test(e.target.value.slice(-1))) {
            return;
        }
        setValueSearch(e.target.value);
    };
    const handleSearchClear = () => {
        setValueSearch('');
        getJournalContPermSelect('');
    };
    const changeUser = (v) => {
        setValuePermUser(v);
    };
    const changeForma = (v) => {
        setValuePermForma(v);
    };
    const handleToggle = (index, item) => {
        setCheckedStates(prev => {
            const newCheckedStates = [...prev];
            newCheckedStates[index] = !newCheckedStates[index];
            return newCheckedStates;
        });
        const id = item.id_T_StudentJournalVisit_settings;
        const field = item.field;
        const on_off = item.on_off === 1 ? 0 : 1;
        updateJournalSettings(id, field, on_off);
    };
    const onEdit = (item) => {
        setIsModal(true);
        setValue({
            idsettings: item.id_T_StudentJournalVisit_settings,
            field: item.field,
            on_off: item.on_off,
            desc: item.description
        });
        setChecked(item.on_off === 1);
    };
    const onEditPermission = (item, index) => {
        setSelectedIndex(index);
        setValuePermUser({
            value: item.id_avn_user,
            label: item.name_user
        });
        setValuePermForma({
            value: item.id_jurnal_permission,
            label: item.jurnal_permission
        });
        setEditFormStatus(item.status);
    };
    const hideModalEdit = () => {
        setIsModal(false);
        setValue({ idsettings: 0, field: 0, on_off: 0, desc: '' });
        setChecked(false);
    };
    const changeField = (e) => {
        const inputValue = e.target.value;
        if (/^\d*$/.test(inputValue) && inputValue.length <= 3) {
            setValue(Object.assign(Object.assign({}, value), { field: Number(inputValue) }));
        }
    };
    const handleToggleEdit = () => {
        setChecked(prev => {
            const newChecked = !prev;
            setValue(prev => (Object.assign(Object.assign({}, prev), { on_off: newChecked ? 1 : 0 })));
            return newChecked;
        });
    };
    const handleAddFormStatus = () => {
        setAddFormStatus(prev => !prev);
    };
    const handleEditFormStatus = () => {
        setEditFormStatus(prev => !prev);
    };
    const onSearch = () => {
        getJournalContPermSelect(valueSearch);
    };
    const getJurnalSettings = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield request('/dekanat/jurnal-settings', 'POST');
        setJournalSet(data);
        setCheckedStates(data.map((setting) => setting.on_off === 1));
    });
    const updateJournalSettings = (id, field, on_off) => __awaiter(void 0, void 0, void 0, function* () {
        const { message, type, data } = yield request('/dekanat/up-jurnal-settings', 'PUT', {
            idsettings: id,
            field: field,
            on_off: on_off
        });
        toast.success(message, type);
        getJurnalSettings();
        setIsModal(false);
    });
    const getPermUsers = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield request('/dekanat/journal-perm-users', 'POST');
        setPermUsers(data);
    });
    const getPermForma = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield request('/dekanat/journal-perm-forma', 'POST');
        setPermForma(data);
    });
    const getJournalContPermSelect = (searchValue = valueSearch) => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield request(`/dekanat/journal-perm?id_avn_user=${id_avn_user}&name_user=${encodeURIComponent(searchValue)}`, 'POST');
        setObjPermForma(data);
    });
    const journalContPermIn = (id_T_StudentJournalVisit_permission, id_avn_user, id_jurnal_permission, status) => __awaiter(void 0, void 0, void 0, function* () {
        if (id_T_StudentJournalVisit_permission === 0) {
            if (!id_avn_user || !id_jurnal_permission) {
                return;
            }
        }
        // For edit mode, check if no changes were made
        if (id_T_StudentJournalVisit_permission !== 0 && selectedIndex !== null) {
            const original = objForma[selectedIndex];
            if (id_avn_user === original.id_avn_user &&
                id_jurnal_permission === original.id_jurnal_permission &&
                status === original.status) {
                setSelectedIndex(null);
                return;
            }
        }
        const { message, type, data2 } = yield request('/dekanat/journal-perm-in', 'PUT', {
            T_StudentJournalVisit_permission: id_T_StudentJournalVisit_permission,
            id_avn_user: id_avn_user,
            jurnal_permission: id_jurnal_permission,
            status: status
        });
        toast[type]((data2 === null || data2 === void 0 ? void 0 : data2.SMS) || message);
        getJournalContPermSelect();
        setCheckAddForm(false);
        setSelectedIndex(null);
        setValuePermUser({ value: null, label: '' });
        setValuePermForma({ value: null, label: '' });
        setAddFormStatus(false);
        setEditFormStatus(false);
    });
    const DeleteJournalPerm = (id) => __awaiter(void 0, void 0, void 0, function* () {
        const { message, type, data2 } = yield request('/dekanat/delete-journal-perm', 'DELETE', {
            T_StudentJournalVisit_permission: id
        });
        getJournalContPermSelect();
        setCheckAddForm(false);
        setSelectedIndex(null);
        setValuePermUser({ value: null, label: '' });
        setValuePermForma({ value: null, label: '' });
        setAddFormStatus(false);
        setEditFormStatus(false);
        const toastMessage = (data2 === null || data2 === void 0 ? void 0 : data2.SMS) || message;
        toast[type](toastMessage);
    });
    useEffect(() => {
        getJurnalSettings();
        getPermUsers();
        getPermForma();
        getJournalContPermSelect();
    }, []);
    return (_jsx(ModalWindow, Object.assign({ title: t('settings_options'), hide: hideModal }, { children: _jsxs("div", Object.assign({ ref: blockRef, className: "display-contents" }, { children: [_jsx("div", Object.assign({ className: "flex justify-content-end mb-1" }, { children: _jsx(ReportActions, { compact: true, source: blockRef, fileName: "nastroyki-dostupa", name: String(t('settings_options')) }) })), _jsxs("table", Object.assign({ className: styles.table }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { className: "text-center" }), _jsx("th", { className: "text-center" }), _jsx("th", { className: "text-center" }), _jsx("th", { className: "text-center" })] }) }), _jsx("tbody", { children: journalSet.map((setting, index) => (_jsxs("tr", Object.assign({ style: { cursor: 'pointer' } }, { children: [_jsx("td", { children: setting.description }), _jsx("td", { children: setting.field }), _jsx("td", { children: _jsx("img", { src: Edit, alt: "settings", style: { cursor: 'pointer', width: '20px' }, onClick: () => onEdit(setting) }) }), _jsx("td", { children: _jsxs("label", Object.assign({ className: styles.autoSaverSwitch }, { children: [_jsx("input", { disabled: true, type: "checkbox", name: `autoSaver-${index}`, checked: checkedStates[index] }), _jsx("span", Object.assign({ className: styles.slider }, { children: _jsx("span", { className: styles.dot }) }))] })) })] }), index))) })] })), _jsx(TkSettings, {}), _jsx(OwnScheduleSetting, {}), _jsxs("div", Object.assign({ className: styles.accesses_block }, { children: [_jsxs("div", Object.assign({ className: styles.accesses_header }, { children: [_jsxs("div", Object.assign({ className: styles.accesses_header_left }, { children: [_jsx("h4", { children: t('accesses') }), _jsx("div", Object.assign({ onClick: () => {
                                                setCheckAddForm(true);
                                                setValuePermUser({ value: null, label: '' });
                                                setValuePermForma({ value: null, label: '' });
                                            }, className: styles.accesses_add }, { children: t('add') }))] })), _jsxs("form", Object.assign({ className: "w-100 flex justify-content-between align-items-center", style: { gap: '4px' }, onSubmit: e => {
                                        e.preventDefault();
                                        onSearch();
                                    } }, { children: [_jsx("div", Object.assign({ style: { width: '100%', flex: 2, position: 'relative' } }, { children: _jsx(Input, { placeholder: t('placeholder_search'), value: valueSearch, onChange: change, className: "w-100", type: "search", style: { height: 24, margin: 0 } }) })), _jsx("div", Object.assign({ onClick: onSearch, className: styles.accesses_add }, { children: t('search') }))] }))] })), checkAddForm ? (_jsx("div", Object.assign({ className: styles.accesses_body }, { children: _jsxs("table", Object.assign({ className: styles.accesses_table }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ className: "text-center" }, { children: t('user_full_name') })), _jsx("th", Object.assign({ className: "text-center" }, { children: t('formm') })), _jsx("th", Object.assign({ className: "text-center" }, { children: t('status') })), _jsx("th", Object.assign({ className: "text-center" }, { children: t('action') }))] }) }), _jsx("tbody", { children: _jsxs("tr", Object.assign({ style: { cursor: 'pointer' } }, { children: [_jsx("td", { children: _jsx(SelectCustom, { value: valuePermUser, options: permUsers.map(item => ({
                                                            value: item.id_AVN_user,
                                                            label: item.name_user
                                                        })), isSearchable: true, onChange: changeUser }) }), _jsx("td", { children: _jsx(SelectCustom, { value: valuePermForma, options: permForma.map(item => ({
                                                            value: item.id_jurnal_permission,
                                                            label: item.jurnal_permission
                                                        })), onChange: changeForma }) }), _jsx("td", { children: _jsx("input", { type: "checkbox", className: styles.accesses_checkbox, checked: addFormStatus, onChange: handleAddFormStatus }) }), _jsx("td", { children: _jsxs("div", Object.assign({ className: styles.accsess_action }, { children: [_jsx("img", { onClick: () => journalContPermIn(0, valuePermUser === null || valuePermUser === void 0 ? void 0 : valuePermUser.value, valuePermForma === null || valuePermForma === void 0 ? void 0 : valuePermForma.value, addFormStatus), src: save_big, alt: "save_ic" }), _jsx("i", { onClick: () => {
                                                                    setCheckAddForm(false);
                                                                    setValuePermUser({ value: null, label: '' });
                                                                    setValuePermForma({ value: null, label: '' });
                                                                    setAddFormStatus(false);
                                                                    setSelectedIndex(null);
                                                                }, className: "fa-solid fa-x", style: { fontSize: 20, cursor: 'pointer' } })] })) })] })) })] })) }))) : (_jsx("div", Object.assign({ className: styles.accesses_body }, { children: _jsxs("table", Object.assign({ className: styles.accesses_table }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ className: "text-center" }, { children: t('user_full_name') })), _jsx("th", Object.assign({ className: "text-center" }, { children: t('formm') })), _jsx("th", Object.assign({ className: "text-center" }, { children: t('status') })), _jsx("th", Object.assign({ className: "text-center" }, { children: t('action') }))] }) }), _jsx("tbody", { children: objForma.map((list, index) => (_jsxs("tr", Object.assign({ style: { cursor: 'pointer' } }, { children: [_jsx("td", { children: index === selectedIndex ? (_jsx(SelectCustom, { value: valuePermUser, options: permUsers.map(item => ({
                                                            value: item.id_AVN_user,
                                                            label: item.name_user
                                                        })), isSearchable: true, onChange: changeUser })) : (list.name_user) }), _jsx("td", { children: index === selectedIndex ? (_jsx(SelectCustom, { value: valuePermForma, options: permForma.map(item => ({
                                                            value: item.id_jurnal_permission,
                                                            label: item.jurnal_permission
                                                        })), onChange: changeForma })) : (list.jurnal_permission) }), _jsx("td", { children: index === selectedIndex ? (_jsx("input", { type: "checkbox", className: styles.accesses_checkbox, checked: editFormStatus, onChange: handleEditFormStatus })) : (_jsx("input", { type: "checkbox", className: styles.accesses_checkbox, checked: list.status, readOnly: true })) }), _jsx("td", { children: _jsxs("div", Object.assign({ className: styles.accsess_action }, { children: [index === selectedIndex && (_jsx("img", { onClick: () => journalContPermIn(list.id_T_StudentJournalVisit_permission, index === selectedIndex
                                                                    ? valuePermUser === null || valuePermUser === void 0 ? void 0 : valuePermUser.value
                                                                    : list.id_avn_user, index === selectedIndex
                                                                    ? valuePermForma === null || valuePermForma === void 0 ? void 0 : valuePermForma.value
                                                                    : list.id_jurnal_permission, index === selectedIndex
                                                                    ? editFormStatus
                                                                    : list.status), src: save_big, alt: "save_ic" })), _jsx("img", { onClick: () => onEditPermission(list, index), src: Edit, alt: "edit_ic" }), _jsx("img", { onClick: () => DeleteJournalPerm(list.id_T_StudentJournalVisit_permission), src: Del, alt: "del_ic" })] })) })] }), index))) })] })) })))] })), isModal && (_jsx(ModalWindow, Object.assign({ title: t('change'), hide: hideModalEdit }, { children: _jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: styles.editMod }, { children: [_jsx("p", { children: value.desc }), _jsx("div", Object.assign({ style: { padding: 2 } }, { children: _jsx(Input, { placeholder: t(''), value: String(value.field), onChange: changeField, className: "w-100", type: "text", style: { margin: 0 } }) })), _jsxs("label", Object.assign({ className: styles.autoSaverSwitch }, { children: [_jsx("input", { type: "checkbox", checked: checked, onChange: handleToggleEdit }), _jsx("span", Object.assign({ className: styles.slider }, { children: _jsx("span", { className: styles.dot }) }))] }))] })), _jsx("div", Object.assign({ className: "mt-4 flex justify-content-end" }, { children: _jsx(Button, { className: "bg-color-primary w-25", value: t('save'), onClick: () => updateJournalSettings(value.idsettings, value.field, value.on_off) }) }))] }) })))] })) })));
};
export default ModalSet;
